export const SEARCH_BUSINESS_WATCHER = 'SEARCH_BUSINESS_WATCHER';
export const SEARCH_BUSINESS_SUCCESS = 'SEARCH_BUSINESS_SUCCESS';
export const SEARCH_BUSINESS_FAILED = 'SEARCH_BUSINESS_FAILED';
